import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useMembershipDetailsStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
            minHeight: '100%'
        },
        headWrapper: {
            backgroundColor: '#FAFAFA',
            paddingLeft: 16,
            paddingRight: 16,
            paddingBottom: 10,
            paddingTop: 20,
            [theme.breakpoints.up('md')]: {
                paddingLeft: '25px',
                paddingRight: '25px',
                paddingTop: 28
            }
        },
        wrapperContainer: {
            padding: '0',
            width: '100%',
            height: '100%'
        },
        content: {
            padding: theme.spacing(2),
            paddingTop: 0,
            backgroundColor: '#FFF',
            borderRadius: theme.shape.borderRadius,
            [theme.breakpoints.down('sm')]: {
                paddingLeft: 0,
                paddingRight: 0,
                paddingTop: 0
            }
        },
        headerContainer: {
            paddingLeft: 0,
            paddingRight: 0,
            marginBottom: 25,
            [theme.breakpoints.down('sm')]: {
                alignItems: 'flex-start'
            }
        },
        headerContainerCentered: {
            paddingLeft: 0,
            paddingRight: 0,
            marginBottom: 25,
            [theme.breakpoints.down('sm')]: {
                alignItems: 'center'
            }
        },
        contentSummaryCard: {
            'display': 'flex',
            'gap': 15,
            'marginTop': 15,
            'marginBottom': 15,
            'overflowX': 'auto',
            'scrollbarWidth': 'none',
            '&::-webkit-scrollbar': {
                display: 'none'
            },
            [theme.breakpoints.down('sm')]: {
                padding: '0 10px',
                marginRight: -15,
                paddingLeft: 15,
                paddingRight: 15,
                marginLeft: -15
            }
        },
        cardSummaryContainer: {
            [theme.breakpoints.down(800)]: {
                width: '170px',
                minWidth: '170px',
                maxWidth: '170px'
            }
        },
        cardSummary: {
            borderRadius: 14,
            border: '1px solid #D4D4D4'
        },
        SelectionBar: {
            [theme.breakpoints.up('md')]: {
                marginTop: 25,
                backgroundColor: '#FFF',
                marginBottom: 10
            },
            [theme.breakpoints.down('sm')]: {
                'paddingTop': 10,
                'paddingBottom': 10,
                'width': 'calc(100% + 30px)',
                'marginLeft': -15,
                'marginRight': -15,
                'overflowX': 'auto',
                'whiteSpace': 'nowrap',
                'WebkitOverflowScrolling': 'touch',
                'scrollbarWidth': 'none',
                '&::-webkit-scrollbar': {
                    display: 'none'
                },
                '& > div:first-child': {
                    marginLeft: 15
                },
                '& > div:last-child': {
                    marginRight: 15
                }
            }
        },
        noMobile: {
            [theme.breakpoints.down('md')]: {
                display: 'none'
            }
        },

        customBadge: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 50,
            color: '#fff',
            fontSize: 15,
            transform: 'none',
            position: 'relative',
            padding: '0px',
            height: '27px',
            marginLeft: 10,
            fontWeight: 500,
            [theme.breakpoints.down('sm')]: {
                marginTop: 4,
                marginLeft: 0
            }
        },
        membershipTitle: {
            display: 'flex',
            alignItems: 'center',
            [theme.breakpoints.down('md')]: {
                flexDirection: 'column',
                alignItems: 'flex-start',
                [`& $customBadge`]: {
                    marginTop: 4,
                    marginLeft: 0
                }
            }
        },
        badgeActive: {
            backgroundColor: '#5E8677'
        },
        badgeInactive: {
            backgroundColor: '#F4F3F0',
            color: '#000'
        },
        membershipOptionsButton: {
            'all': 'unset',
            'fontSize': 21,
            '& svg': {
                display: 'block'
            }
        },
        toolbarButton: {
            fontSize: 18
        },
        headerRightContent: {
            display: 'flex',
            alignItems: 'center',
            gap: 15,
            [theme.breakpoints.down('sm')]: {
                flexDirection: 'column-reverse',
                alignItems: 'center',
                gap: 8
            }
        },
        seeDetailsButton: {
            'background': 'none',
            'border': 'none',
            'color': '#000',
            'cursor': 'pointer',
            'fontSize': 16,
            'fontWeight': 500,
            'textDecoration': 'underline',
            'fontFamily': 'Poppins',
            '&:hover': {
                textDecoration: 'none'
            }
        },
        searchBarContainer: {
            paddingTop: 15,
            paddingBottom: 15,
            [theme.breakpoints.down('sm')]: {
                paddingBottom: 0
            }
        },
        headerActionPopup: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            paddingTop: '25px'
        },
        headerActionPopupTitle: {
            fontWeight: 600,
            color: '#000000',
            fontSize: '16px',
            textAlign: 'left',
            display: 'block',
            width: '100%'
        },
        alertsContainer: {
            marginTop: 25,
            marginBottom: 0
        },
        alertMessage: {
            marginBottom: '10px !important'
        }
    })
);

export default useMembershipDetailsStyles;
